import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Container } from "semantic-ui-react";
import { useSelector } from "react-redux";

export default function ToPaymentModal({ isLoadingModal = true }) {
  const { responsive } = useSelector((state) => state.app);

  return (
    <ModalWrapper
      size="tiny"
      style={{ width: !responsive.isMobile ? 400 : "98%" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      isClose={false}
    >
      <div className="loading-modal">
        <Container textAlign="center">
          <div>
            <div className="modal-blue-text" style={{ fontSize: 20 }}>
              {isLoadingModal
                ? "Please wait a few seconds…"
                : "Loading payment page…"}
            </div>
            <div className="modal-blue-text">
              {isLoadingModal
                ? "Don’t refresh this page or close your browser."
                : "Please don’t refresh this page or close your browser."}
            </div>
          </div>
        </Container>
      </div>
    </ModalWrapper>
  );
}
